import {useJsonStore} from "@/store/jsonStore";
import {getJsonData, getProvinceOssListApi} from "@/utils/untils";
import {useInfoStore} from "@/store";
export const globalMixin = {
    data() {
        return {
        }
    },
    computed: {
        userBaseInfo(){
            return useInfoStore().baseInfo
        }
    },
    methods: {
        clearBaseInfo() {
          localStorage.removeItem('baseInfo');
            const obj = useInfoStore()
            obj.setKey('baseInfo',{})
            obj.setKey('backUrl','')
            obj.setKey('backType',0)
        },
        getGlobalOssData(key='') {
            const obj = useJsonStore()
            return key? obj.ossList?.[key]:  obj.ossList
        },
        async getGlobalProvinceData({provinceId,key,info}={}) {
            try {
                const obj = useJsonStore()
                const id = provinceId||localStorage.getItem('provinceId')
                const urlList = await getProvinceOssListApi(id)
                // console.error('getGlobalProvinceData',urlList)
                if (key&&Object.keys(info).length>0) {
                    return await getJsonData({url:urlList[key],...info})
                }else {
                    return key? urlList?.[key]: urlList
                }
            }catch (e) {

            }
        },
        getGlobalDomainData(key='') {
            const obj = useJsonStore()
            return key? obj.domainData?.[key]:  obj.domainData
        },
        getGlobalConfig(key='') {
            const obj = useJsonStore()
            return key? obj.config?.[key]:  obj.config
        },
        startAllLoading(){
            useInfoStore().setKey('loading', true)
        },
        endAllLoading(){
            useInfoStore().setKey('loading', false)
        }

    },
    created() {
    },
};
